var tabs= document.querySelectorAll('.custom-tab');
    var tabContents= document.querySelectorAll('.custom__tab-content');
  
    tabs.forEach(function(tab){
        tab.addEventListener('click',function(){
  
            contentId = this.dataset.contentId;
            content = document.getElementById(contentId);
  
            tabContents.forEach(function(content){
                content.classList.remove('active');
            });
  
            tabs.forEach(function(tab){
                tab.classList.remove('active');
            });
  
            this.classList.add('active');
            content.classList.add('active');
        });
    });


    var swiper = new Swiper(".tabSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        "@0.00": {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        "@1.00": {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        "@1.50": {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      },
    });
    
    var display = document.getElementById('feature_description');
    function showdesc(content){
      console.log(content);
      display.innerHTML = content;
    };